import { inject, WritableSignal, signal } from "@angular/core";
import { CalculationTodayStoreService } from "@bitwarden/web-vault/app/services/store/calculation-today/calculation-today.store.service";
import { ImportStoreService } from "@bitwarden/web-vault/app/services/store/import/import.store.service";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";
import { SignalSubscriptionImpl } from "../../data-subscription";
import { getInstitutionTableViews } from "../institution.table";
import {
  InstitutionOrigin,
  InstitutionTableView,
} from "@bitwarden/web-vault/app/models/types/institution.type";

export type TableSource = InstitutionTableView;
export type TableFilter = { [key in InstitutionOrigin]: boolean };

/**
 * This class only need to deal with angular dependency
 * and the core logic is in getAccountTableViews function which can be easily unit tested
 */
export class InstitutionDetailsTableSubscription extends SignalSubscriptionImpl<TableSource[]> {
  protected filter: WritableSignal<TableFilter> = signal<TableFilter>(null);
  userStoreService: UserStoreService;
  importStoreService: ImportStoreService;
  calculationStoreService: CalculationTodayStoreService;

  constructor() {
    super();
    this.userStoreService = inject(UserStoreService);
    this.importStoreService = inject(ImportStoreService);
    this.calculationStoreService = inject(CalculationTodayStoreService);
  }

  get source() {
    const institutionViews = this.userStoreService.institutions
      .institutionViews()
      .sort((a, b) => a.name?.localeCompare(b.name));
    const filter = this.filter();
    const institutionTableViews = getInstitutionTableViews(institutionViews);
    return this.updateFilteredData(filter, institutionTableViews);
  }

  private updateFilteredData(selectedFilter: TableFilter, data: TableSource[]) {
    if (!selectedFilter) {
      return data;
    }
    const noFilterSelected = Object.values(selectedFilter).every((value) => !value);
    if (noFilterSelected) {
      return data;
    }

    return data.filter((row) => selectedFilter[row.type as InstitutionOrigin]);
  }
}
